module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-available-red-887d63.svg";